function Nav() {
  return (
    <div className="notFound">
      <div>
        <h2> Wrong Adress!</h2>
        <h1> 404 Not Found</h1>
      </div>
    </div>
  );
}

export default Nav;
